var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSidebarGuiasHover68X56(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 56,
    viewBox: "0 0 68 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30 18.75C28.2051 18.75 26.75 20.2051 26.75 22V34C26.75 35.7949 28.2051 37.25 30 37.25H38C39.7949 37.25 41.25 35.7949 41.25 34V24.7241C41.25 24.4317 41.1475 24.1485 40.9603 23.9239L37.0235 19.1998C36.786 18.9148 36.4342 18.75 36.0633 18.75H30ZM25.25 22C25.25 19.3766 27.3766 17.25 30 17.25H36.0633C36.8794 17.25 37.6534 17.6125 38.1759 18.2395L42.1126 22.9636C42.5245 23.4578 42.75 24.0808 42.75 24.7241V34C42.75 36.6234 40.6234 38.75 38 38.75H30C27.3766 38.75 25.25 36.6234 25.25 34V22Z",
    fill: "#61B09D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37 17.75C37.4142 17.75 37.75 18.0858 37.75 18.5V22C37.75 22.6904 38.3096 23.25 39 23.25H41.5C41.9142 23.25 42.25 23.5858 42.25 24C42.25 24.4142 41.9142 24.75 41.5 24.75H39C37.4812 24.75 36.25 23.5188 36.25 22V18.5C36.25 18.0858 36.5858 17.75 37 17.75Z",
    fill: "#61B09D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.25 28C29.25 27.5858 29.5858 27.25 30 27.25H38C38.4142 27.25 38.75 27.5858 38.75 28C38.75 28.4142 38.4142 28.75 38 28.75H30C29.5858 28.75 29.25 28.4142 29.25 28Z",
    fill: "#61B09D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.25 33C29.25 32.5858 29.5858 32.25 30 32.25H34C34.4142 32.25 34.75 32.5858 34.75 33C34.75 33.4142 34.4142 33.75 34 33.75H30C29.5858 33.75 29.25 33.4142 29.25 33Z",
    fill: "#61B09D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarGuiasHover68X56);
export default __webpack_public_path__ + "static/media/SIDEBAR-GUIAS-HOVER_68X56.561def48f4ad2720f9fce21b7a764fa4.svg";
export { ForwardRef as ReactComponent };